<div [ngClass]="separatorClass()" [ngStyle]="separatorStyle()"></div>
